// document ready pure javascript
export default function initSeek(){
    // check button is available
    if(document.querySelector(".seek-btn.button")){
        // on button click get selected radio button value and redirect
        const btn = document.querySelector<HTMLButtonElement>(".seek-btn.button");
        if(!btn)return;

        btn.addEventListener("click", function (){
            const selectEl = document.querySelector<HTMLSelectElement>("input[name=\"selected_seek\"]:checked");
            if(!selectEl)return;
            const selectedValue = selectEl.value;
            window.location.href = selectedValue;
        });

        const selectEls = document.querySelectorAll<HTMLInputElement>("input[name=\"selected_seek\"]");
        selectEls.forEach(select => {
            select.addEventListener("change", function (){
                btn.disabled = false;
            });
        });
    }

    const shareBtn = document.querySelector<HTMLButtonElement>(".btn.share");
    if(shareBtn){
        shareBtn.addEventListener("click", function (){
            shareBtn.classList.add("share--active");
        }, { once: true });
    }

    // scan qr code script start that contains the qr code scanner, open camera, read qr code and print the result

    /*// on button click open camera
    document.querySelector('.scan-qr-code').addEventListener('click', function () {
        // check if qr code scanner is available
        if (window.qrcode) {
            // open camera
            window.qrcode.start();
        }else{
            // print error
            document.querySelector('.qr-result').innerHTML = 'QR code scanner not available';
        }
    });
 
    // capture qr code result
    if (window.qrcode) {
        window.qrcode.callback = function (result) {
            // print result
            document.querySelector('.qr-result').innerHTML = result;
        };
    }*/
}